(function ($) {
	$.fbqTrack = function (element, options) {

		var $c = $(element),

			fbqTrack = (function ($c, o) {
				var defaults = {
					
				}; 

				var _o = {},
					$fbqTrack = null
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
				},

				_TrackLead = function () {
					fbq('track', 'Lead');
				},

				_BindEvents = function () {
					$('.track-lead').click(function(){
						_TrackLead();
					});
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.fbqTrack = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('fbqTrack')) {
				var plugin = new $.fbqTrack(this, options);
				$(this).data('fbqTrack', plugin);
			}
		});
	};
})(jQuery);